import { Button, FormLayout, PasswordInput, SubmitButton, TextInput } from '@expressable/syntax-ds';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { useRequestResetPasswordFormContext } from '../context';

type Props = {
  isLoading: boolean;
};

export const FormUi = ({ isLoading }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { register } = useFormContext();
  const { onBack } = useRequestResetPasswordFormContext();

  return (
    <>
      <FormLayout.Fields>
        <TextInput
          {...register('code')}
          data-testid="form-confirmation-code"
          autoFocus
          label={t('login.form.fields.emailCode')}
        />
        <PasswordInput
          {...register('password')}
          data-testid="form-new-password"
          hint={t('login.newPassword.passwordRequirements')}
          label={t('login.form.fields.newPassword')}
        />
        <PasswordInput
          {...register('passwordConfirm')}
          data-testid="form-confirm-new-password"
          label={t('login.form.fields.confirmPassword')}
        />
      </FormLayout.Fields>

      <FormLayout.GlobalErrors message={t('intake.form.validationErrors')} />

      <FormLayout.CTA column>
        <SubmitButton data-testid="form-change-password-button" size="lg" fullWidth>
          {t('login.passwordReset.submit')}
        </SubmitButton>

        {!onBack && (
          <Link to="/">
            <Button data-testid="form-return-log-in-button" disabled={isLoading} variant="link" size="lg" fullWidth>
              {t('login.passwordReset.returnToLogin')}
            </Button>
          </Link>
        )}
        {onBack && (
          <Button
            data-testid="form-return-log-in-button"
            disabled={isLoading}
            variant="link"
            size="lg"
            fullWidth
            onClick={onBack}
          >
            {t('login.passwordReset.returnToLogin')}
          </Button>
        )}
      </FormLayout.CTA>
    </>
  );
};
